export const dayMenuItems = [
  {
    icon: 'view',
    command: { func: 'showDaysBefore' },
    param: 'daysBefore',
    getText: param => `${param ? 'Скрыть' : 'Показать'} предыдущие дни`,
  },
  {
    icon: 'date',
    action: 'shipping_bids_edit',
    command: { func: 'setBid', type: 'dialog_load_day' },
    getText: () => 'Новый день',
  },
  {
    icon: 'edit',
    action: 'shipping_bids_edit',
    command: { func: 'setBid', type: 'dialog_edit_shipping' },
    getText: () => 'Редактировать',
  },
  {
    icon: 'map-location',
    command: { func: 'setBid', type: 'openTheMap' },
    getText: () => 'На карте',
  },
  {
    icon: 'document-add',
    command: { func: 'toArchive' },
    param: 'isArchive',
    getText: param => (param ? 'Восстановить' : 'В архив'),
  },
  {
    command: 'setPaid',
  },
]
export const dayMenuItemsHidden = [
  {
    icon: 'printer',
    action: 'payments_bank_modal',
    command: { func: 'onPaymentBankModalHandler' },
    getText: () => 'Выгрузить в банк',
  },
  {
    icon: 'download',
    action: 'payments_bank_modal',
    command: { func: 'onDownloadReport' },
    param: 'count',
    getText: param => `Скачать файлы с отчетом (${param})`,
  },
  {
    icon: 'edit-outline',
    action: 'payments_bank_modal',
    command: { func: 'onGenerateReportModalHandler' },
    param: 'count',
    getText: param => `Сформировать отчет по.. (${param})`,
  },
  {
    icon: 'document-checked',
    command: { func: 'onReport' },
    param: 'count',
    getText: param => `отчет эксп. сдан (${param})`,
  },
  {
    icon: 'truck',
    command: { func: 'setBid', type: 'dialogInstruction' },
    getText: () => 'Поручение на перевозку',
  },
  {
    icon: 'document',
    command: { func: 'setBid', type: 'dialogContract' },
    getText: () => 'Договор-заявка/заявка',
  },
  {
    icon: 'user',
    action: 'responses_list_modal',
    command: { func: 'setBid', type: 'dialogResponses' },
    getText: () => 'Перевозчики',
  },
  {
    icon: 'bell',
    action: 'send_notification',
    command: { func: 'setBid', type: 'dialogSendNotification' },
    getText: () => 'Отправить уведомление',
  },
  {
    icon: 'warning-outline',
    action: 'payments_bank_modal',
    command: { func: 'setHot' },
    getText: () => 'Добавить/Убрать отметку "Горящая"',
  },
  {
    icon: 'tickets',
    action: 'edit_registry',
    command: { func: 'editRegistry' },
    getText: () => 'Настройка отправки реестра',
  },
  // {
  //   icon: 'tickets',
  //   action: 'edit_registry',
  //   command: { func: 'editRegistry' },
  //   getText: () => 'Настройка отправки реестра',
  // },
]

export const dayAddRules = {
  load_date: {
    required: true,
    message: 'Укажите дату начала погрузки',
    trigger: 'blur',
  },
  cars_count: {
    type: 'number',
    min: 1,
    required: true,
    trigger: 'blur',
    message: 'Укажите колличество авто',
  },
  price_from_storage_bidder: {
    type: 'number',
    min: 0.01,
    required: true,
    trigger: 'blur',
    message: 'Укажите цену перевозки',
  },
  price_from_field_bidder: {
    type: 'number',
    min: 0.01,
    required: true,
    trigger: 'blur',
    message: 'Укажите цену уборки',
  },
}
